import Vue from 'vue';

Vue.component('locations-list', require('./LocationsList').default);
Vue.component('choose-locations-limit', require('./ChooseLocationsLimit').default);
Vue.component('choose-facebook-pages-modal', require('./ChooseFacebookPagesModal').default);

Vue.component('google-my-business-authorization', require('./CoogleMyBusinessAuthorization').default);
Vue.component('housecall-pro-authorization-complete', require('./HousecallProAuthorizationComplete').default);

Vue.component('foreup-integration', require('./integrations/ForeupIntegration').default);
Vue.component('flare-integration', require('./integrations/FlareIntegration').default);

Vue.component('sites-review-card', require('./SitesReviewCard').default);

Vue.component('location-review-widget', require('./LocationReviewWidget').default);

Vue.component('integration-connection-list', require('./integrations/IntegrationConnectionList').default);
Vue.component('integration-form-custom-id-selector', require('./integrations/IntegrationFormCustomIdSelector').default);
Vue.component('integration-form-checkbox-selector', require('./integrations/IntegrationFormCustomIdSelector').default);
